import { render, staticRenderFns } from "./RequestStatusChip.vue?vue&type=template&id=a82c4ac8&scoped=true&lang=pug&"
import script from "./RequestStatusChip.vue?vue&type=script&lang=js&"
export * from "./RequestStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82c4ac8",
  null
  
)

export default component.exports